export enum SustainabilityFormStatus {
	InProgress = 'InProgress',
	WaitingForApproval = 'WaitingForApproval',
	Approved = 'Approved',
	Rejected = 'Rejected'
}
